import { hemorrhoid } from './initial/flow';

export const HemorrhoidFlows = { hemorrhoid };
